module.exports = __webpack_public_path__ + "img/mirka-accounting3.cbd41a0a.png";